module.exports = __webpack_public_path__ + "img/errorText.578a0641.png";